<template>
  <router-view class="mx-0 px-0" /> 
</template>
<script>
  export default {
    name: 'void',
  }
</script>
<style scoped>
</style>
